import { useEffect } from "react";

const KEYBOARD_OPEN_PX = 80;

export function visualViewportMetrics(win = typeof window === "undefined" ? undefined : window) {
  if (!win) {
    return {
      height: 0,
      width: 0,
      offsetTop: 0,
      offsetLeft: 0,
      keyboardInset: 0,
    };
  }
  const vv = win.visualViewport;
  const innerHeight = win.innerHeight || 0;
  const innerWidth = win.innerWidth || 0;
  const height = vv?.height ?? innerHeight;
  const width = vv?.width ?? innerWidth;
  const offsetTop = vv?.offsetTop ?? 0;
  const offsetLeft = vv?.offsetLeft ?? 0;
  const keyboardInset = Math.max(0, Math.round(innerHeight - height - offsetTop));
  return { height, width, offsetTop, offsetLeft, keyboardInset };
}

export function applyVisualViewportCssVars(
  el,
  metrics = visualViewportMetrics()
) {
  if (!el?.style) return;
  el.style.setProperty("--vv-offset-top", `${metrics.offsetTop}px`);
  el.style.setProperty("--vv-offset-left", `${metrics.offsetLeft}px`);
  el.style.setProperty("--vv-width", `${metrics.width}px`);
  el.style.setProperty("--vv-height", `${metrics.height}px`);
  el.style.setProperty("--vv-keyboard-inset", `${metrics.keyboardInset}px`);
  el.classList.toggle("pm-keyboard-open", metrics.keyboardInset > KEYBOARD_OPEN_PX);
}

export function useVisualViewportCssVars() {
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => applyVisualViewportCssVars(root, visualViewportMetrics());
    apply();
    const vv = window.visualViewport;
    window.addEventListener("resize", apply);
    vv?.addEventListener("resize", apply);
    vv?.addEventListener("scroll", apply);
    return () => {
      window.removeEventListener("resize", apply);
      vv?.removeEventListener("resize", apply);
      vv?.removeEventListener("scroll", apply);
      root.classList.remove("pm-keyboard-open");
      ["--vv-offset-top", "--vv-offset-left", "--vv-width", "--vv-height", "--vv-keyboard-inset"].forEach(
        (name) => root.style.removeProperty(name)
      );
    };
  }, []);
}
